import { isEmpty } from 'lodash';

import { MINERVA_API_URL } from '@/config';

import { http } from '@/plugins/http';
import types from './mutation-types';

export function setToken({ commit, state }, token) {
  commit(types.SET_TOKEN, token);

  return Promise.resolve(token);
}

export function setDevice({ commit, state }, device) {
  commit(types.SET_DEVICE, device);

  return Promise.resolve(device);
}

export function fetchUser({ dispatch }) {
  return http.post(`${MINERVA_API_URL}/users/sign-in`, {})
    .then(res => (
      dispatch('setUserInStore', res.data)
    ))
    .then(userInfo => (
      dispatch('checkUserTutorial')
        .then(() => (userInfo))
    ))
    .catch((err) => {
      if (err.response && err.response.status === 404) {
        console.error('user not found in DB!');
      }

      return Promise.reject(err);
    })
    .catch((err) => {
      // TODO: handle error
      dispatch('setToken', '');

      console.error('err while fetching user:', err);
      return Promise.reject(err);
    });
}

export function fetchUserRelationships({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/users/relationships`)
    .then(res => (
      dispatch('setUserRelationships', res.data.data)
    ))
    .catch((err) => {
      console.error('err while fetching user relationships', err);
      return Promise.reject(err);
    });
}

export function setUserInStore({ commit }, userInfo) {
  commit(types.SET_USER, userInfo);

  return Promise.resolve(userInfo);
}

export function setUserPropertyInStore({ commit }, setInfo) {
  commit(types.SET_PROPERTY, setInfo);

  return Promise.resolve();
}

export function setUserRelationships({ commit }, userRelationshipList) {
  commit(types.SET_USER_RELATIONSHIPS, userRelationshipList);

  return Promise.resolve();
}

export function signOut({ commit }) {
  commit(types.SIGN_OUT);

  return Promise.resolve();
}

export function checkUserToken({ state }) {
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token);
  }

  return Promise.reject('NO_TOKEN');
}

export function fetchUserLicence({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/users/me/current-user-licence`)
    .then(res => (
      dispatch('setUserLicence', res.data)
    ))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function setUserLicence({ commit, state }, userLicence) {
  commit(types.SET_LICENCE, userLicence);

  return Promise.resolve(userLicence);
}

export function fetchPremiumSchool({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/is-premium-school `)
    .then(res => (
      dispatch('setPremiumSchool', res.data)
    ))
    .catch((err) => {
      if (err.response.status === 404) {
        return false;
      }

      return Promise.reject(err);
    });
}

export function setPremiumSchool({ commit, state }, premiumSchool) {
  commit(types.SET_PREMIUM_SCHOOL, premiumSchool);

  return Promise.resolve(premiumSchool);
}

export function fetchGrades({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/grades`)
    .then(res => (
      dispatch('setGrades', res.data)
    ))
    .catch(err => (
      Promise.reject(err)
    ));
}

export function setGrades({ commit, state }, grades) {
  commit(types.SET_GRADES, grades);

  return Promise.resolve(grades);
}



// WEBPACK FOOTER //
// ./src/app/auth/store/actions.js